var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-switch',_vm._b({attrs:{"size":"mini"},on:{"change":_vm.handleChange},model:{value:(_vm.mValue),callback:function ($$v) {_vm.mValue=$$v},expression:"mValue"}},'el-switch',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }